import { Route, Routes } from 'react-router'

import { NotFound } from '../common/NotFound'
import Report from './Report'

export const UsageReport = () => {
  return (
    <Routes>
      <Route index element={<Report />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
